module.exports = __webpack_public_path__ + "static/Foodanddelivery-f4709f99da7f7bafa84873b276ff340d.svg";